import React, { useEffect } from "react";
import { useStore } from "../../../store/useStore";
import Title from "antd/lib/typography/Title";
import { Button, Form, Input, notification, Select } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { updateUserAttributes } from "../../../store/actions";
import useStatefulForm from "../../../hooks/useStatefulForm";
import { sanitizeUserAttributes } from "../../../util";
import { Countries } from "../../../util/countries";

const UpdateProfileForm: React.FC = () => {
  const { form, isSubmitting, setSubmitting } = useStatefulForm();
  const { state, dispatch } = useStore();

  useEffect(() => {
    form.resetFields();
  }, [state.user, form]);

  const initialValues = {
    email: state.user?.attributes.email,
    given_name: state.user?.attributes.given_name,
    family_name: state.user?.attributes.family_name,
    phone_number: state.user?.attributes.phone_number,
  };

  return (
    <>
      <Form
        name="profile-update-form"
        form={form}
        className="flex flex-col"
        initialValues={initialValues}
        onFinish={async (values) => {
          setSubmitting(true);
          let onlyDefinedValues: any = {};
          Object.entries(values).forEach(([k, v]) => {
            if (v) onlyDefinedValues[k] = v;
          });

          try {
            await dispatch(
              updateUserAttributes(sanitizeUserAttributes(onlyDefinedValues))
            );
            notification.success({
              message: "Profile updated",
              placement: "bottomRight",
            });
            setSubmitting(false);
          } catch (error) {
            notification.error({
              message: "Error updating profile",
              placement: "bottomRight",
            });
            setSubmitting(false);
          }
        }}
      >
        <Form.Item
          name="email"
          hasFeedback
          validateStatus={initialValues.email ? "" : "validating"}
          rules={[{ required: true, message: "Please input your email!" }]}
        >
          <Input
            prefix={
              <div className="flex h-full">
                <MailOutlined className="self-center" />
              </div>
            }
            disabled={isSubmitting}
            placeholder="Email"
          />
        </Form.Item>
        <Form.Item
          name="given_name"
          hasFeedback
          validateStatus={initialValues.given_name ? "" : "validating"}
        >
          <Input disabled={isSubmitting} placeholder="First name" />
        </Form.Item>
        <Form.Item
          name="family_name"
          hasFeedback
          validateStatus={initialValues.family_name ? "" : "validating"}
        >
          <Input disabled={isSubmitting} placeholder="Surname" />
        </Form.Item>
        <Form.Item
          name="phone_number"
          hasFeedback
          validateStatus={initialValues.phone_number ? "" : "validating"}
          rules={[
            {
              required: true,
              message:
                "Please enter a valid phone number, including area prefix e.g +44 123 456789",
            },
          ]}
        >
          <Input
            style={{ width: "100%" }}
            placeholder="Phone number"
            disabled={isSubmitting}
          />
        </Form.Item>

        <Form.Item className="flex flex-col">
          <div className="flex flex-col text-center">
            <Button type="primary" htmlType="submit" loading={isSubmitting}>
              Update profile
            </Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default UpdateProfileForm;
